<div
	class="image"
	[style.max-width]="imageWidth"
>
	<img
		[src]="imageSrc"
		[alt]="imageAlt"
	/>
</div>
